import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ProductSectionCache } from '../model/landingModel';
import { Module } from '../model/ModuleModel';
import { isPlatformBrowser } from '@angular/common';
import { LandingModelService } from './landingModel.service';

@Injectable({ providedIn: 'root' })
export class SectionModulesService {
  private readonly UNIQUE_HOME_ROOT_AB_ALLOWED_PRODUCTS: ReadonlySet<string> = new Set(['hotels', 'flights', 'packages']);
  productSectionCache: { [key: string]: ProductSectionCache } = {};
  originalUrl: string;
  homeForBuyers = {
    'flights': new RegExp('/(vuelos|passagens-aereas|flights)'),
    'hotels': new RegExp('/(hoteles|hoteis|hotels)'),
    'combinedproducts': new RegExp('/(paquetes|pacotes|packages)'),
    'vr': new RegExp('/(alquileres-vacacionales|alugueis-por-temporada|vacation-rentals|alquileres-temporarios|rentas-vacacionales|arriendos|alquileres|alugueis-para-temporada|arriendos-temporales|rentas-temporales)'),
    'activities': new RegExp('/(actividades|activities|atracoes-turisticas)'),
    'cars': new RegExp('/(autos|carros|cars)'),
    'insurance': new RegExp('/(asistencia-al-viajero|seguro-viagem|travel-assistance|seguro-de-viaje|asistencia-de-viaje)'),
    'transfers': new RegExp('/(traslados|transfer)')
  }

  constructor(private httpClient: HttpClient, @Inject(PLATFORM_ID) private platformId: string,
    private landingModelService: LandingModelService) {
    if (isPlatformBrowser(this.platformId)) {
      this.originalUrl = location.pathname;
    }
  }

  getSectionProductModules = (url, product): Promise<ProductSectionCache> => {
    const productSectionKey = this.getProductSectionKey(product, url);

    return new Promise((resolve, reject) => {
      if (this.productSectionCache[productSectionKey]) {
        this.productSectionCache[productSectionKey].is_from_browser_cache = true;
        resolve(JSON.parse(JSON.stringify(this.productSectionCache[productSectionKey])));
        return;
      }

      url = this.resolveUrlForBuyers(url);

      let reqUrl = `/nymeria-gui/data/model?originalUrl=${url}&responseType=PRODUCT_SECTION_MODULES&product=${product}`;

      this.httpClient.get(reqUrl)
        // @ts-ignore
        .subscribe((response: ProductSectionCache) => {
          this.productSectionCache[productSectionKey] = {
            ...response,
            is_from_browser_cache: false,
            is_from_server_cache: response.new_relic_data.tracking_info?.cacheResponse
          };
          resolve(JSON.parse(JSON.stringify(this.productSectionCache[productSectionKey])))
        }, error => reject(error));
    });
  }


  getAjaxModulesData = (url, product): Promise<{ modules: Module[], trackers: any }> => {
    const productSectionKey = this.getProductSectionKey(product, url);

    return new Promise((resolve, reject) => {
      url = this.resolveUrlForBuyers(url);

      let reqUrl = `/nymeria-gui/data/model?originalUrl=${url}&responseType=ONLY_AJAX_MODULES&product=${product}`;

      this.httpClient.get(reqUrl)
      // @ts-ignore
        .subscribe((response: { modules: Module[], trackers: any }) => {
          resolve(JSON.parse(JSON.stringify(response)))
        }, error => reject(error));
    });
  }

  resolveUrlForBuyers(url: string) {
    // Este chequeo se hace solo para usuarios compradores porque tiene una url particular
    if (this.originalUrl.includes('page-for-buyer-users')) {
      Object.entries(this.homeForBuyers).forEach(([key, value]) => {
        if (url.match(value) != null) {
          url = `/home/page-for-buyer-users/${key}`;
        }
      });
    }
    return url;
  }

  saveInitialProductSectionCache(product, url: string, productSectionModules: ProductSectionCache) {
    const productSectionKey = this.getProductSectionKey(product, url);
    this.productSectionCache[productSectionKey] = JSON.parse(JSON.stringify(productSectionModules));
  }

  cleanCache() {
    this.productSectionCache = {};
  }

  getProductSectionKey(product: string, url: string) {
    const productSectionKey = this.isUniqueHomeRootAbTestEnabledFor(product) ? `${product}_/${product}/` : `${product}_${url}`;
    return productSectionKey;
  }

  isUniqueHomeRootAbTestEnabledFor(product: string): boolean {
    if (!this.UNIQUE_HOME_ROOT_AB_ALLOWED_PRODUCTS.has(product)) { return false }

    const landingModel = this.landingModelService.getLandingModel();
    return !!(landingModel.abTests?.tests?.nymeriaUniqueHomeRoot?.enabled == "true");
  }
}